import React, { useState, useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Redirect } from 'react-router-dom'
import ProfileSetupForm from './ProfileSetupForm';
import { trackMetaPixel } from "../../lib/metaPixel";
import wheatfieldVideo from "../../resources/wheatfield.mp4";


export default function ProfileSetupFormPage() {
  const [profileComplete, setProfileComplete] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [retryKey, setRetryKey] = useState(0)
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  useEffect(() => {
  trackMetaPixel("UserStartedProfile");
  }, []);
  
  useEffect(() => {
    const checkProfile = async () => {
      if (isLoading) return
      if (!isAuthenticated) {
        setLoading(false)
        return
      }

      setLoading(true)
      setError("")
        try {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              audience: process.env.REACT_APP_API_AUDIENCE,
            }
          })

          const response = await fetch(`${apiUrl}/api/users/check-profile`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })

          if (!response.ok) {
            throw new Error(`Profile check failed (${response.status})`)
          }
          const profileComplete = await response.json()
          if (typeof profileComplete !== "boolean") {
            throw new Error("Profile check returned an invalid response.")
          }
          setProfileComplete(profileComplete)
        } catch (error) {
          console.error("Error fetching profile:", error)
          setError("We couldn't check your profile. Please retry.")
        } finally {
          setLoading(false)
        }
    }

    checkProfile()
  }, [isAuthenticated, isLoading, getAccessTokenSilently, apiUrl, retryKey])

if (loading) {
  return <div role="status">Checking your profile...</div>
}

if (!isAuthenticated) {
  return <Redirect to="/public" />
}

if (error) {
  return (
    <div role="alert" className="mx-auto max-w-lg p-8 text-center">
      <p>{error}</p>
      <button type="button" onClick={() => setRetryKey((value) => value + 1)}>Retry</button>
    </div>
  )
}

if (isAuthenticated && profileComplete) {
  // profile is complete → send them home
  return <Redirect to="/" />
}
  return (
<div className="relative min-h-screen overflow-hidden">
      <video
        className="absolute inset-0 h-full w-full object-cover"
        src={wheatfieldVideo}
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="absolute inset-0 " aria-hidden />
      <div className="relative z-10 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
        <ProfileSetupForm isDarkMode />
      </div>
    </div>
  );
}
